<div class="app-container">
    <ion-phaser [game]="game"></ion-phaser>
</div>